module.exports = __webpack_public_path__ + "static/media/boss-clear.105e119f.png";